import React from 'react';
import { animated } from 'react-spring';
import Slide from './Slide';
import { SLIDESHOW_HEIGHT } from './DeviationSlideshow';
import useSlideAnimation from './hooks/useSlideAnimation';
import s from './DeviationSlideshow.scss';
const AnimDiv = animated.div;
const Track = ({ items, containerWidth, useCoverMode, animationState })=>{
    const transitions = useSlideAnimation(animationState);
    // Immediate siblings will be preloaded for performance reasons
    const { index: currentIndex } = animationState;
    const preloadIndexes = items.reduce((acc, _, index)=>{
        if (currentIndex !== index && Math.abs(currentIndex - index) < 2) {
            acc.push(index);
        }
        return acc;
    }, []);
    const renderSlide = (index, visible = true)=>/*#__PURE__*/ React.createElement(Slide, {
            key: index,
            deviation: items[index],
            containerWidth: containerWidth,
            useCoverMode: useCoverMode,
            active: currentIndex === index,
            visible: visible
        });
    return /*#__PURE__*/ React.createElement("div", {
        className: s['track'],
        style: {
            height: SLIDESHOW_HEIGHT
        }
    }, transitions.map(({ item: index, key, props })=>/*#__PURE__*/ React.createElement(AnimDiv, {
            key: key,
            style: props
        }, renderSlide(index), items.length > 1 && /*#__PURE__*/ React.createElement("div", {
            className: s['slide-counter']
        }, `${index + 1}/${items.length}`))), preloadIndexes.map((index)=>renderSlide(index, false)));
};
export default Track;

//# sourceMappingURL=Track.js.map